import { useTranslation } from "react-i18next";

/** De client waarmee de MCP-server z'n token aanvraagt (migratie 0060). */
export const AI_CLIENT = "mcp";

/**
 * Label voor een branch of plateau dat een AI via de MCP aanmaakte. Daar mag
 * de AI zelf snapshots terugzetten en het plateau weggooien; wat de AI deed,
 * draait Ctrl+Z in de browser niet terug.
 */
export function AiBadge({ client }: { client: string | null | undefined }) {
  const { t } = useTranslation();
  if (client !== AI_CLIENT) return null;
  return (
    <span
      className="rounded bg-violet-100 px-1.5 py-0.5 font-semibold text-[10px] text-violet-700"
      title={t("roadmap.aiBadgeTitle")}
    >
      {t("roadmap.aiBadge")}
    </span>
  );
}
